var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1127_7374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C10.5562 0 11.883 0.533746 12.9803 1.60124C14.0767 2.66946 14.625 3.96111 14.625 5.47619V7.66667H15.75C16.3687 7.66667 16.8986 7.88097 17.3396 8.30957C17.7799 8.7389 18 9.25476 18 9.85714V20.8095C18 21.4119 17.7799 21.9278 17.3396 22.3571C16.8986 22.7857 16.3687 23 15.75 23H2.25C1.63125 23 1.10175 22.7857 0.6615 22.3571C0.2205 21.9278 0 21.4119 0 20.8095V9.85714C0 9.25476 0.2205 8.7389 0.6615 8.30957C1.10175 7.88097 1.63125 7.66667 2.25 7.66667H3.375V5.47619C3.375 3.96111 3.92363 2.66946 5.02088 1.60124C6.11738 0.533746 7.44375 0 9 0ZM9 2.19048C8.0625 2.19048 7.26562 2.50992 6.60938 3.14881C5.95312 3.7877 5.625 4.56349 5.625 5.47619V7.66667H12.375V5.47619C12.375 4.56349 12.0469 3.7877 11.3906 3.14881C10.7344 2.50992 9.9375 2.19048 9 2.19048ZM9 13.1429C8.38125 13.1429 7.85175 13.3572 7.4115 13.7858C6.9705 14.2151 6.75 14.731 6.75 15.3333C6.75 15.9357 6.9705 16.4516 7.4115 16.8809C7.85175 17.3095 8.38125 17.5238 9 17.5238C9.61875 17.5238 10.1486 17.3095 10.5896 16.8809C11.0299 16.4516 11.25 15.9357 11.25 15.3333C11.25 14.731 11.0299 14.2151 10.5896 13.7858C10.1486 13.3572 9.61875 13.1429 9 13.1429Z",
    fill: "#F89500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1127_7374",
    x: 0,
    y: 0,
    width: 18.3333,
    height: 23.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7374"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cb0f6e4f465ddf12b48f04698d65f220.svg";
export { ForwardRef as ReactComponent };